<div class="price {{cell.class}}">
  <i class="icon icon-arrow-{{cell.class}}-general"></i
  ><span class="data">{{cell.value}}</span>
</div>
